import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { testimonials } from '@/mocks/comics';

export default function About() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="min-h-screen bg-background-50">
        <section className="pt-24 pb-8 md:pt-28 md:pb-12 bg-background-100">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-800 font-medium">关于我们</span>
            </nav>

            <div className="text-center max-w-2xl mx-auto">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
                关于奇妙漫画网
              </h1>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                奇妙漫画网是一个专注于免费韩漫在线阅读的平台，致力于为漫画爱好者提供高质量、多元化的韩国漫画资源。
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">品牌故事</h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    奇妙漫画网诞生于一群热爱韩国漫画的年轻人之手。我们深知漫画爱好者对优质内容和良好阅读体验的渴望，因此创立了这个为韩漫迷提供免费在线漫画阅读服务的平台。
                  </p>
                  <p>
                    从最初收录几百部漫画作品，到如今汇集上万部精选韩国漫画资源，奇妙漫画网始终坚持<strong className="text-foreground-800">免费阅读、高品质内容、流畅体验</strong>三大原则，赢得了数百万读者的信赖与喜爱。
                  </p>
                  <p>
                    我们与多位韩国知名漫画作者和出版社建立了合作关系，确保第一时间为读者带来最新、最热门的连载作品。同时，我们也注重发掘优秀的新人作品，为读者提供更多元化的漫画选择。
                  </p>
                </div>

                <div className="grid grid-cols-3 gap-6 mt-8">
                  <div className="text-center p-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-bold text-primary-500">10,000+</div>
                    <div className="text-xs text-foreground-500 mt-1">漫画资源</div>
                  </div>
                  <div className="text-center p-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-bold text-accent-500">500万+</div>
                    <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
                  </div>
                  <div className="text-center p-4 rounded-xl bg-background-100">
                    <div className="text-2xl md:text-3xl font-bold text-secondary-500">日更</div>
                    <div className="text-xs text-foreground-500 mt-1">持续更新</div>
                  </div>
                </div>
              </div>

              <div className="relative rounded-xl overflow-hidden aspect-[4/3] bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20cozy%20reading%20nook%20with%20a%20tablet%20displaying%20colorful%20webtoon%20art%2C%20surrounded%20by%20books%20and%20a%20warm%20lamp%2C%20soft%20natural%20lighting%2C%20comfortable%20atmosphere%2C%20minimalist%20interior%20design%2C%20coral%20and%20cream%20color%20palette%2C%20editorial%20photography%20style&width=1200&height=900&seq=about-brand-manga&orientation=landscape"
                  alt="奇妙漫画网品牌形象"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">读者口碑</h2>
              <p className="text-sm text-foreground-500 mt-2">来自真实读者的真诚评价</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-4xl mx-auto">
              {testimonials.map((t, idx) => (
                <div key={idx} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{t.comment}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-xs font-medium text-primary-600">{t.name[0]}</span>
                    </div>
                    <span className="text-sm font-medium text-foreground-800">{t.name}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16">
          <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-5">联系我们</h2>
                <p className="text-sm text-foreground-500 mb-6">
                  如果您有任何问题、建议或合作意向，欢迎通过下方表单与我们联系。我们会在 1-2 个工作日内回复您。
                </p>

                <div className="space-y-4">
                  <div className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <span>contact@qimiaomanhua.com</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-wechat-line text-accent-600"></i>
                    </div>
                    <span>qimiaomanhua</span>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-600">
                    <div className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-weibo-line text-secondary-600"></i>
                    </div>
                    <span>@奇妙漫画网</span>
                  </div>
                </div>
              </div>

              <div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

function ContactForm() {
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormState('success');
      return;
    }

    setFormState('loading');
    setErrorMessage('');

    try {
      const formData = new FormData(form);
      formData.delete('website_alt');
      const urlSearchParams = new URLSearchParams();
      formData.forEach((value, key) => {
        urlSearchParams.append(key, value as string);
      });

      const response = await fetch('https://readdy.ai/api/form/d9osntaftmtnfcfh0dcg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlSearchParams.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setFormState('success');
        form.reset();
        setCharCount(0);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setErrorMessage(serverMsg || '提交失败，请稍后重试');
        setFormState('error');
      }
    } catch {
      setErrorMessage('网络错误，请检查网络连接后重试');
      setFormState('error');
    }
  };

  if (formState === 'success') {
    return (
      <div className="bg-background-100 rounded-xl p-8 text-center border border-background-200/70">
        <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center">
          <i className="ri-check-line text-2xl text-primary-500"></i>
        </div>
        <h3 className="text-lg font-heading font-bold text-foreground-800 mb-2">提交成功！</h3>
        <p className="text-sm text-foreground-500">感谢您的留言，我们会在1-2个工作日内回复您。</p>
        <button
          onClick={() => setFormState('idle')}
          className="mt-4 text-sm text-primary-500 hover:text-primary-600 font-medium"
        >
          发送新消息
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="bg-background-100 rounded-xl p-6 border border-background-200/70" data-readdy-form>
      <div className="space-y-4">
        <div>
          <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
          <input
            id="contact-name"
            name="name"
            type="text"
            required
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-400/20 transition-all"
            placeholder="请输入您的姓名"
          />
        </div>
        <div>
          <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
          <input
            id="contact-email"
            name="email"
            type="email"
            required
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-400/20 transition-all"
            placeholder="请输入您的邮箱"
          />
        </div>
        <div>
          <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
            留言 <span className="text-foreground-400 font-normal">（{charCount}/500）</span>
          </label>
          <textarea
            id="contact-message"
            name="message"
            required
            maxLength={500}
            rows={4}
            onChange={(e) => setCharCount(e.target.value.length)}
            className="w-full px-4 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-400/20 transition-all resize-none"
            placeholder="请输入您的留言内容（500字以内）"
          ></textarea>
        </div>
        <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="hp-field" />
        <button
          type="submit"
          disabled={formState === 'loading'}
          className="w-full px-6 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap"
        >
          {formState === 'loading' ? '发送中...' : '发送留言'}
        </button>
      </div>
      {formState === 'error' && (
        <p className="text-sm text-red-500 mt-3">{errorMessage || '提交失败，请稍后重试'}</p>
      )}
    </form>
  );
}